/**
 * auth-api-serverless wrappers for DM persona login.
 *
 * After verification-api returns a `verification_id` and a status indicating
 * whether the user is new (status 200) or existing (status 201), the front-end
 * exchanges the verification id for an access_token via signup or login.
 *
 * Both endpoints respond with `{ data: { user_id, username, access_token } }`.
 */

import { dmRequest, DM_ENV } from './dmApiClient';

const API_PREFIX = '/api/v0';

function unwrap(res) {
  const d = res?.data || {};
  return {
    userId: typeof d.user_id === 'number' ? d.user_id : Number(d.user_id),
    username: d.username || '',
    accessToken: d.access_token || '',
    raw: res,
  };
}

export async function dmUserLogin(emailAddress, verificationId) {
  const res = await dmRequest(DM_ENV.authApiBase, `${API_PREFIX}/auth/login`, {
    method: 'POST',
    body: {
      email_address: emailAddress,
      verification_id: verificationId,
    },
  });
  return unwrap(res);
}

export async function dmUserSignup(emailAddress, verificationId) {
  const res = await dmRequest(DM_ENV.authApiBase, `${API_PREFIX}/auth/signup`, {
    method: 'POST',
    body: {
      email_address: emailAddress,
      verification_id: verificationId,
    },
  });
  return unwrap(res);
}

/**
 * Test-only user lookup. Returns { userId, username } or throws ApiError(404).
 * Pass exactly one of `email` or `username`.
 */
export async function lookupUser({ email, username }) {
  if (!email && !username) {
    throw new Error('lookupUser: provide email or username');
  }
  const query = email ? { email } : { username };
  const res = await dmRequest(DM_ENV.authApiBase, `${API_PREFIX}/test/users/lookup`, {
    method: 'GET',
    query,
  });
  const d = res?.data || {};
  return {
    userId: typeof d.user_id === 'number' ? d.user_id : Number(d.user_id),
    username: d.username || '',
  };
}
